/**
 * Unde e «acasa» pentru fiecare rol — partea PURA a lui `getUserHomePage`.
 *
 * De ce exista ca fisier separat: `getUserHomePage` traia in closure-ul providerului React, iar testul
 * resolverului (`resolve-post-auth-target.test.ts`) avea o COPIE a lui. O repointare gresita a functiei
 * reale nu putea pica niciun test, fiindca testele verificau copia. Acum providerul si testele cheama
 * aceeasi functie.
 *
 * ⚠️ NU e «unde ateriza userul dupa login» — asta o decide `resolvePostAuthTarget` (`landing()`), care
 * intoarce home-ul doar la `pathname === null`. Aici se schimba doar ce inseamna «home» pentru un rol;
 * `landing()` ramane neatins (o alta forma ar pinui rolurile pe home: incidentul din 2026-08-21).
 */

import type { Role, RolesType } from '../../../providers/routes-provider.types';

export interface HomePageContext {
  PATHS: Record<string, string>;
  PAGES: Record<string, string>;
  ROLES: RolesType;
}

export function homePathForRole(
  role: Role | undefined,
  { PATHS, PAGES, ROLES }: HomePageContext
): string {
  if (!role) return PATHS[PAGES.HOME];
  if (role === ROLES.ELEV) return PATHS[PAGES.ACASA];
  if (role === ROLES.PROFESOR) return PATHS[PAGES.ACASA];
  if (role === ROLES.ADMIN) return PATHS[PAGES.SCHOOLS_GRAPHIC_REPORT];
  if (role === ROLES.DBEST) return PATHS[PAGES.FINAL_REPORT];
  if (role === ROLES.LOGISTIC) return PATHS[PAGES.WASTE_COLLECTION_TABLE];
  return PATHS[PAGES.HOME];
}
